import ViewReverse from '../../components/ViewReverse';
import images from '../../constants/images';
import WelcomeFunctional from './index.function';
import Language from '../../components/Language';
import ViewItems from '../../components/ViewItems';
import { fontSizes } from '../../constants/constants';
import { Button, Text } from '../../components/SecondaryMarket';
import { cn } from '../../utils/utils';
import icons from '../../constants/icons';

const Welcome = () => {
  const { navigate, TextWeight, isArabic, getContentKey } = WelcomeFunctional();

  return (
    <div className='flex flex-col h-screen bg-no-repeat bg-cover bg-bottom p-8' style={{ backgroundImage: `url(${images.heroBg})` }}>
      <ViewReverse className={'justify-between'}>
        <img src={images.logo_white} className='h-14 w-14' />
        <Language color={'text-white'} lineColor={'bg-white'} arabicIcon={icons.arabic_lang_white_icon} />
      </ViewReverse>

      <div className='flex-1' />

      <ViewItems className={cn('w-full md:w-[30%] ps-6', isArabic ? 'self-end' : 'self-start')}>
        <Text
          text={getContentKey("welcome_new_account")}
          size={fontSizes.h45}
          weight={TextWeight.headingBold}
          className={'leading-[50px] text-white'}
        />
        <Text text={getContentKey("complete_required_section")} className={'mt-2 text-white'} weight={TextWeight.light} />

        <Button text={getContentKey("get_started")} className={'mt-4'} onClick={() => window.location.href = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`} />
      </ViewItems>
    </div>
  );
};

export default Welcome;
